<template>
    <div class="megamenu-container">
      <!-- <b-tree-view
              :data="treeData"
              nodeLabelProp="name_en"
              @nodeSelect="nodeSelect"
              :renameNodeOnDblClick="false"
          >
          </b-tree-view> -->
  
      <!--<div class="container">
          <ul id="menu">
             <li v-for="(treeDataSi, key) in treeData" v-if="treeData">
                  <a href="">{{treeDataSi.name_en}}</a>
                  <ul v-if="treeDataSi.children.length != 0">
                      <li v-for="(treeDataSiChildren, key) in treeDataSi.children" v-if="treeDataSi.children">
                          <a href="">{{treeDataSiChildren.name_en}}</a>
                          <ul v-if="treeDataSiChildren.children.length != 0">
                              <li v-for="(treeDataSiChildrenFirst, key) in treeDataSiChildren.children" v-if="treeDataSiChildren.children">
                                  <a href="">{{treeDataSiChildrenFirst.name_en}}</a></li>
                          </ul>
                      </li>
                  </ul>
              </li> 
              <li>
                  <a href="">menu 1</a>
                  <ul>
                      <li>
                          <a href="">menu 1a</a>
                      </li>
                      <li> 
                          <a href="">menu 1aa</a>
                      </li>
                  </ul>
              </li>
              <li>
                  <a href="">menu 2</a>
                  <ul>
                      <li>
                          <a href="">menu 2a</a>
                      </li>
                      <li> 
                          <a href="">menu 2aa</a>
                      </li>
                  </ul>
              </li>
          </ul>
      </div>-->
  
      <!-- <hsc-menu-style-white>
              <hsc-menu-bar style="border-radius: 0 0 4pt 0;">
                  
                  <hsc-menu-bar-item v-for="(treeDataSi, key) in treeData" :label="treeDataSi.name_en" v-if="treeData">
  
                      <hsc-menu-item v-for="(treeDataSiChildren, key) in treeDataSi.children" :label="treeDataSiChildren.name_en" v-if="treeDataSi.children"  @click="window.alert('Undo')">
  
                          <hsc-menu-item v-for="(treeDataSiChildrenFirst, key) in treeDataSiChildren.children" :label="treeDataSiChildrenFirst.name_en" v-if="treeDataSiChildren.children" @click="window.alert('Undo')">
                          </hsc-menu-item>
  
                      </hsc-menu-item>
                  </hsc-menu-bar-item>
              </hsc-menu-bar>
          </hsc-menu-style-white> -->
      <nav class="navbar navbar-expand-lg navbar-light sticky-top p-0" v-if="is_show_header">
        <div class="container-fluid p-0">
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#mobile_nav"
            aria-controls="mobile_nav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <!-- Right-aligned icon link for mobile and tablet -->
          <div class="d-lg-none ml-auto" v-if="showCsIconLink">
            <a class="nav-link" @click="openPopup" href="javascript:void(0);">
              <i class="fas fa-shopping-cart"></i>
            </a>
          </div>
          <div class="collapse navbar-collapse" id="mobile_nav">
            <div class="container">
              <ul class="navbar-nav navbar-light" v-if="menusList">
  
                <li class="nav-item dmenu"
                  v-for="(treeDataSi, key) in menusList"
                  style="display: block; position: relative; float: left"
                  :key="key"
                >
                  <button
                    class="nav-link dropdown-toggle cursor-pointer"
                    id="tyreType"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    type="button"
                    style="background: none; border: none;"
                  >
                    {{ menusList[key][`name_${current}`] }}
                    <i class="fa fa-caret-down"></i>
                  </button>
                  <div class="dropdown-menu megamenu sm-menu" aria-labelledby="tyreBrands"
                    :style="[
                      treeDataSi.children.length <= 5
                        ? { width: '250px' }
                        : { width: '250px' },
                    ]"
                  >
                    <div class="container">
                      <div class="row pl-1">
                        <div :style="{'width' : (treeDataSi.children.length > 5 ? '200px' : '250px')}"
                          :class="[
                            treeDataSi.children.length <= 5
                              ? 'col-sm-12 col-lg-12'
                              : 'col-sm-12 col-lg-12',
                          ]"
                          v-for="(treeDataSiChildren, firstKey) in treeDataSi.children" :key="firstKey">
                          <div
                            :class="
                              treeDataSi.type == 'brand'
                                ? 'sub-megamenu-btn'
                                : treeDataSi.type == 'size'
                                ? 'sub-megamenu-btn'
                                : 'sub-megamenu-btn'
                            "
                          >
                            <div v-if="treeDataSi.children && (treeDataSi.type == 'brand' || treeDataSi.type == 'size')">
                              <a v-if="treeDataSi.type == 'brand'" class="dropdown-item"
                                :class="treeDataSiChildren.children.length != 0 ? 'sub-megamenu' : ''"
                                :href="'/brand/' + treeDataSiChildren.brand['0'].slug"
                                >{{ treeDataSi.children[firstKey][`name_${current}`] }}
                                <ul class="menu-level-2" v-if="treeDataSiChildren.children != 0">
                                  <li v-for="(treeDataSiChildrenFirst, secondKey) in treeDataSiChildren.children" :key="secondKey">
                                    <!-- <a v-if="treeDataSiChildrenFirst.brand && treeDataSiChildrenFirst.is_custom != 1" :href="'/brand/'+treeDataSiChildrenFirst.brand['0'].slug">{{treeDataSiChildren.children[secondKey][`name_${current}`]}}</a>
                                                                                              <a v-else :href="treeDataSiChildrenFirst.href">{{treeDataSiChildren.children[secondKey][`name_${current}`]}}</a> -->
  
                                    <a :href="'/brand/' + treeDataSi.children[firstKey].brand['0'].slug + '/model/' + treeDataSiChildrenFirst.tyre_brand_model.slug">
                                        {{ treeDataSiChildren.children[secondKey][`name_${current}`] }}
                                    </a>
                                  </li>
                                </ul>
                              </a>
  
                              <a v-if="treeDataSi.type == 'size'"
                                class="dropdown-item"
                                :class="treeDataSiChildren.children.length != 0 ? 'sub-megamenu' : '' "
                                :href="
                                  '/tyre-size/' +
                                  treeDataSi.children[firstKey].tyre_size_page
                                    .tyre_size_product.width +
                                  '-' +
                                  treeDataSi.children[firstKey].tyre_size_page
                                    .tyre_size_product.height +
                                  'R-' +
                                  treeDataSi.children[firstKey].tyre_size_page
                                    .tyre_size_product.diameter
                                "
                              >
                                {{
                                  treeDataSi.children[firstKey][`name_${current}`]
                                }}
  
                                <ul class="menu-level-2"
                                  v-if="treeDataSiChildren.children != 0"
                                >
                                  <li v-for="( treeDataSiChildrenFirst, secondKey ) in treeDataSiChildren.children" :key="secondKey">
                                    <a :href="'/tyre-size/' + treeDataSiChildrenFirst.href" >{{ treeDataSiChildren.children[secondKey][`name_${current}`] }}</a>
                                  </li>
                                </ul>
                              </a>
                            </div>
                            <div v-else>
                                <ul>
                                    <li v-if="treeDataSi.type == 'season'" class="second-level-mega-menu">
                                        <a class="dropdown-item"
                                           :href="'/season/' + treeDataSiChildren.tyre_season.slug"
                                        >
                                            <img :src="treeDataSiChildren.image_path" class="mega-menu-image" v-if="treeDataSiChildren.image_path !== null" />
                                            <span class="mega-menu-image mega-menu-image-mr-28" v-else></span>
                                            {{ treeDataSi.children[firstKey][`name_${current}`] }}
                                        </a>
                                        <ul class="third-level-mega-menu" v-if="(treeDataSi.children[firstKey][`description_${current}`]) != null">
                                            <li>
                                                <div class="display_content">
                                                    <div class="menu-image-display" v-if="treeDataSiChildren.image_path !== null"><img :src="treeDataSiChildren.image_path" :alt="treeDataSi.children[firstKey][`name_${current}`]"> </div>
                                                    <div class="menu-content-display">
                                                        <p v-if="(treeDataSi.children[firstKey][`description_${current}`]).length >= displayStringLength && !readMore[key+'_'+firstKey]">{{ (treeDataSi.children[firstKey][`description_${current}`]).substring(0,200) + ".." }} </p>
                                                        <p v-if="(treeDataSi.children[firstKey][`description_${current}`]).length <= displayStringLength || readMore[key+'_'+firstKey]">{{ (treeDataSi.children[firstKey][`description_${current}`]) }} </p>
                                                    </div>
                                                    <a :href="'/season/' + treeDataSiChildren.tyre_season.slug"  class="btn-show-more-less">{{ $t('Read more') }}</a>
                                                    <span href="javascript:void(0)" @click="showLess(key+'_'+firstKey)" v-if="false && (treeDataSi.children[firstKey][`description_${current}`]).length >= displayStringLength && readMore[key+'_'+firstKey]" class="btn-show-more-less">Show less</span>
                                                </div>
                                            </li>
                                        </ul>
                                    </li>
                                    <li v-else-if="treeDataSi.type == 'vehicle'" class="second-level-mega-menu">
                                        <a class="dropdown-item" :href="'/tyre/' + treeDataSiChildren.tyre_category[0].slug">
                                          <img :src="treeDataSiChildren.image_path" class="mega-menu-image" v-if="treeDataSiChildren.image_path !== null" />
                                          <span class="mega-menu-image mega-menu-image-mr-28" v-else></span>
                                            {{ treeDataSi.children[firstKey][ `name_${current}`]}}
                                        </a>
                                        <ul class="third-level-mega-menu" v-if="(treeDataSi.children[firstKey][`description_${current}`]) != null">
                                            <li>
                                                <div class="display_content">
                                                    <div class="menu-image-display" v-if="treeDataSiChildren.image_path !== null"><img :src="treeDataSiChildren.image_path" :alt="treeDataSi.children[firstKey][`name_${current}`]"> </div>
                                                    <div class="menu-content-display">
                                                        <p v-if="(treeDataSi.children[firstKey][`description_${current}`]).length >= displayStringLength && !readMore[key+'_'+firstKey]">{{ (treeDataSi.children[firstKey][`description_${current}`]).substring(0,200) + ".." }} </p>
                                                        <p v-if="(treeDataSi.children[firstKey][`description_${current}`]).length <= displayStringLength || readMore[key+'_'+firstKey]">{{ (treeDataSi.children[firstKey][`description_${current}`]) }} </p>
                                                    </div>
                                                    <a :href="'/tyre/' + treeDataSiChildren.tyre_category[0].slug"  class="btn-show-more-less">{{ $t('Read more') }}</a>
                                                    <span href="javascript:void(0)" @click="showLess(key+'_'+firstKey)" v-if="(treeDataSi.children[firstKey][`description_${current}`]).length >= displayStringLength && readMore[key+'_'+firstKey]" class="btn-show-more-less">Show less</span>
                                                </div>
                                            </li>
                                        </ul>
                                    </li>
                                    <li v-else-if="treeDataSi.type == 'article'" class="second-level-mega-menu">
                                        <a class="dropdown-item" :href="'/product-details/' +treeDataSiChildren.type_id">
                                          <img :src="treeDataSiChildren.image_path" class="mega-menu-image" v-if="treeDataSiChildren.image_path !== null" />
                                          <span class="mega-menu-image mega-menu-image-mr-28" v-else></span>
                                            {{ treeDataSi.children[firstKey][`name_${current}`]}}
                                        </a>
                                        <ul class="third-level-mega-menu" v-if="(treeDataSi.children[firstKey][`description_${current}`]) != null">
                                            <li>
                                                <div class="display_content">
                                                    <div class="menu-image-display" v-if="treeDataSiChildren.image_path !== null"><img :src="treeDataSiChildren.image_path" :alt="treeDataSi.children[firstKey][`name_${current}`]"> </div>
                                                    <div class="menu-content-display">
                                                        <p v-if="(treeDataSi.children[firstKey][`description_${current}`]).length >= displayStringLength && !readMore[key+'_'+firstKey]">{{ (treeDataSi.children[firstKey][`description_${current}`]).substring(0,200) + ".." }} </p>
                                                        <p v-if="(treeDataSi.children[firstKey][`description_${current}`]).length <= displayStringLength || readMore[key+'_'+firstKey]">{{ (treeDataSi.children[firstKey][`description_${current}`]) }} </p>
                                                    </div>
                                                    <a :href="'/product-details/' +treeDataSiChildren.type_id"  class="btn-show-more-less">{{ $t('Read more') }}</a>
                                                    <span href="javascript:void(0)" @click="showLess(key+'_'+firstKey)" v-if="(treeDataSi.children[firstKey][`description_${current}`]).length >= displayStringLength && readMore[key+'_'+firstKey]" class="btn-show-more-less">Show less</span>
                                                </div>
                                            </li>
                                        </ul>
                                    </li>

                                    <li class="second-level-mega-menu" v-else>
                                        <a class="dropdown-item" :href="treeDataSiChildren.link" >
                                          <img :src="treeDataSiChildren.image_path" class="mega-menu-image" v-if="treeDataSiChildren.image_path !== null" />
                                          <span class="mega-menu-image mega-menu-image-mr-28" v-else></span>
                                            {{treeDataSi.children[firstKey][`name_${current}`]}}
                                        </a>
                                        <ul class="third-level-mega-menu" v-if="(treeDataSi.children[firstKey][`description_${current}`]) != null">
                                            <li>
                                                <div class="display_content">
                                                    <div class="menu-image-display" v-if="treeDataSiChildren.image_path !== null"><img :src="treeDataSiChildren.image_path" :alt="treeDataSi.children[firstKey][`name_${current}`]"> </div>
                                                    <div class="menu-content-display">
                                                        <p v-if="(treeDataSi.children[firstKey][`description_${current}`]).length >= displayStringLength && !readMore[key+'_'+firstKey]">{{ (treeDataSi.children[firstKey][`description_${current}`]).substring(0,200) + ".." }} </p>
                                                        <p v-if="(treeDataSi.children[firstKey][`description_${current}`]).length <= displayStringLength || readMore[key+'_'+firstKey]">{{ (treeDataSi.children[firstKey][`description_${current}`]) }} </p>
                                                    </div>
                                                    <a :href="treeDataSiChildren.link"  class="btn-show-more-less">{{ $t('Read more') }}</a>
                                                    <span href="javascript:void(0)" @click="showLess(key+'_'+firstKey)" v-if="(treeDataSi.children[firstKey][`description_${current}`]).length >= displayStringLength && readMore[key+'_'+firstKey]" class="btn-show-more-less">Show less</span>
                                                </div>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>

                              <!-- <div class="d-flex align-content-start justify-content-start">
                                                                                      <img :src="treeDataSiChildren.image_path" :alt="treeDataSi.children[firstKey][`name_${current}`]">
                                                                                      <div>
                                                                                          <p>{{ treeDataSi.children[firstKey][`description_${current}`] }}</p>
                                                                                          
                                                                                          <a :href="'/season/'+treeDataSiChildren.tyre_season.slug" v-if="treeDataSi.type == 'season'" >{{ $t('Read more') }}</a>
  
                                                                                          <a v-else-if="treeDataSi.type == 'vehicle'" :href="'/tyre/'+treeDataSiChildren.tyre_category[0].slug">{{ $t('Read more') }}</a>
  
                                                                                          <a v-else-if="treeDataSi.type == 'article'" :href="'/product-details/'+treeDataSiChildren.type_id">{{ $t('Read more') }}</a>
  
                                                                                          <a v-else :href="treeDataSiChildren.link">{{ $t('Read more') }}</a>
  
                                                                                      </div>
                                                                                  </div>  -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </div>

  </template>
  
  <script>
  // import Vue from 'vue'
  // import * as VueMenu from '@hscmap/vue-menu'
  // Vue.use(VueMenu)
  
  // import { bTreeView } from "bootstrap-vue-treeview";
  
  import $ from "jquery";
  import { mapGetters, mapActions } from "vuex";

  export default {
    name: "CustomMenu",
    data() {
      return {
        current: process.env.VUE_APP_I18N_LANG,
        contextMenuItems: [
          // { code: "ADD_NODE", label: "Add node" },
          // { code: "DELETE", label: "Delete node" },
          // { code: "RENAME", label: "Rename node" },
        ],
        updateMenuForm: 0,
        treeData: [],
        items: [],
        selectedNode: null,
        isSelected: false,
        form: {},
        menuId: null,
        menuType: null,
        wantedToEditNewMenu: false,
        wantedToAddNewMenu: false,
        wantedToAddCustomMenu: false,
        envBaseUrl: process.env.VUE_APP_BASE_URL,
        isDanger: false,
        readMore :{},
        displayStringLength : 200
      };
    },
    computed: {
      ...mapGetters("menu", ["menusList"]),
      ...mapGetters("app", ["currentLang"]),
      ...mapGetters("search", ["activeVehicleTypes"]),
      ...mapGetters("cart_popup_mobile", ["isOpen"]),
      ...mapGetters("HeaderFooterControl", ["is_show_header"]),
      showCsIconLink() {
        // Define an array of route paths where you want to show the icon link
        const showOnRoutes = [
          "/cart",
          "/cart/dealer-services",
          "/cart/user-info",
        ]; // Add more routes as needed
        return showOnRoutes.includes(this.$route.path);
      }
    },
    async mounted() {
      await this.fetchMenus();
      /*step one*/
      document.querySelectorAll(".navbar-light .dmenu").forEach(function (element) {
        element.addEventListener("mouseenter", function () {
          element.classList.add("show");
          element.querySelector("#tyreType").setAttribute("aria-expanded", "true");
          element.querySelector(".dropdown-menu").classList.add("show");
        });

        element.addEventListener("mouseleave", function () {
          element.classList.remove("show");
          element.querySelector("#tyreType").setAttribute("aria-expanded", "false");
          element.querySelector(".dropdown-menu").classList.remove("show");
        });
      });

      /*step two*/
      document.querySelectorAll(".sub-megamenu-btn a").forEach(function (element) {
        element.addEventListener("mouseenter", function () {
          const ul = element.querySelector("ul");
          if (ul) {
            ul.style.display = ul.style.display === "none" || ul.style.display === "" ? "block" : "none";
          }
        });

        element.addEventListener("mouseleave", function () {
          const ul = element.querySelector("ul");
          if (ul) {
            ul.style.display = ul.style.display === "none" || ul.style.display === "" ? "block" : "none";
          }
        });
      });

      /*step three*/
      document.querySelectorAll(".navbar-light .dmenu .megamenu .second-level-mega-menu").forEach(function (element) {
        if (element.querySelector(".third-level-mega-menu") && element.querySelector(".third-level-mega-menu").style) {
          element.addEventListener("mouseenter", function () {
            element.querySelector(".third-level-mega-menu").style.display = "block";
          });

          element.addEventListener("mouseleave", function () {
            element.querySelector(".third-level-mega-menu").style.display = "none";
          });
        }
      });

      /*$(document).ready(function ($) {
        setTimeout(function () {
          $(".sub-megamenu-btn").on(
            "mouseenter mouseleave",
            "a",
            function () {
              $(this).find("ul").fadeToggle();
            }
          );
  
          if (window.innerWidth > 1280) {
            // Mega menu open on hover
            $(".navbar-light .dmenu").hover(
              function () {
                $(this).addClass("show");
                $(this).find("#tyreType").attr("aria-expanded", "true");
                $(this).find(".dropdown-menu").addClass("show");
              },
              function () {
                $(this).removeClass("show");
                $(this).find("#tyreType").attr("aria-expanded", "false");
                $(this).find(".dropdown-menu").removeClass("show");
              }
            );

              /*$(".navbar-light .dmenu .megamenu .second-level-mega-menu").hover(
                  function () {
                      $(this).find(".third-level-mega-menu").show();
                  },
                  function () {
                      $(this).find(".third-level-mega-menu").hide();
                  }
              );
          }
        }, 3000);
      });*/
    },
    created: function () {
      this.current = this.currentLang == "en_GB" ? "en" : "fi";
    },
    watch: {
      currentLang: {
        handler() {
          this.current = this.currentLang == "en_GB" ? "en" : "fi";
        },
      },
    },
  
    methods: {
      ...mapActions("menu", ["fetchMenus"]),
      ...mapActions("cart_popup_mobile", ["cpmSetIsOpen"]),
      openPopup() {
        this.cpmSetIsOpen(true);
      },
      forceRerenderUpdateMenuForm() {
        this.updateMenuForm += 1;
      },
        showMore(index) {
            this.$set(this.readMore, index, true);
        },
        showLess(index) {
            this.$set(this.readMore, index, false);
        },
      nodeSelect(node, isSelected) {
        if (isSelected) {
          this.selectedNode = node.data;
          this.isSelected = true;
          this.wantedToEditNewMenu = true;
          this.menuId = node.data.id;
          this.menuType = node.data.type;
          this.forceRerenderUpdateMenuForm();
        } else if (node.data == this.selectedNode) {
          this.selectedNode = null;
          this.isSelected = false;
        }
      },
    },
  };
  </script>
  
  <style scoped>
  /* ul { font-family: Arial, Verdana;   font-size: 14px;   margin: 0;   padding: 0;   list-style: none; } 
  ul li { display: block; position: relative;
      float: left; } 
  li ul { display: none; } 
  ul li a { display: block; text-decoration: none; color: #ffffff; border-top: 1px solid #ffffff; padding: 5px 15px 5px 15px; background: #2C5463; margin-left: 1px; white-space: nowrap; } 
  ul li a:hover { background: #617F8A; } 
  li:hover ul {   display: block;   position: absolute; z-index: 2; } 
  li:hover li {   float: none;   font-size: 11px; } 
  li:hover a { background: #617F8A; } 
  li:hover li a:hover { background: #95A9B1; } */
  
  .navbar {
    background-color: rgba(218, 157, 38, 0.9);
    padding-top: 0;
    padding-bottom: 0;
    box-shadow: 1px 3px 4px 0 #adadad33;
  }
  .navbar-light .navbar-brand {
    color: #2196f3;
  }
  .navbar-light .navbar-nav .nav-link {
    color: #fff;
  }
  .navbar-light .navbar-brand:focus,
  .navbar-light .navbar-brand:hover {
    color: #1ebdc2;
  }
  .navbar-light .navbar-nav .nav-link:focus,
  .navbar-light .navbar-nav .nav-link:hover {
    color: #fff;
  }
  @media (min-width: 992px) and (max-width: 1440px) {
    .navbar-light .navbar-nav .nav-link {
      margin: 0 10px !important;
    }
  }
  .navbar-light .navbar-nav .nav-link {
    padding: 5px 0;
    transition: 0.3s;
    margin: 0 15px;
    font-size: 14px;
    font-weight: normal;
  }
  .navbar-light .navbar-nav .nav-link:focus,
  .navbar-light .navbar-nav .nav-link:hover {
    background-color: rgb(218, 157, 38);
    transition: 0.3s;
    border-bottom: 1px solid #ffffff;
  }
  .dropdown-item:focus,
  .dropdown-item:hover {
    color: #fff;
    text-decoration: none;
    background-color: #da9d26 !important;
    border-bottom: 0.6px solid rgba(255, 255, 255, 1);
  }
  .sm-menu {
    border-radius: 0px;
    border: 0px;
    top: 29px;
    box-shadow: rgba(173, 173, 173, 0.2) 1px 3px 4px 0px;
  }
  .dropdown-item {
    color: #fff;
    font-size: 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.6);
    padding: 0.7rem 0;
  }
  .dropdown-item.active,
  .dropdown-item:active {
    color: #fff;
    text-decoration: none;
    background-color: #2196f3;
  }
  .dropdown-toggle::after {
    display: none;
  }
  .navbar-toggler {
    outline: none !important;
  }
  .navbar-tog {
    color: #1ebdc2;
  }
  .megamenu-li {
    position: static;
  }
  .megamenu {
    position: absolute;
    /* width: 450px; */
    left: 0;
    right: 0;
    /* padding: 15px; */
    background-color: #da9d26;
    border-top: 1px solid rgba(255, 255, 255, 0.3);
  }
  .megamenu h6 {
    margin-left: 21px;
  }
  .megamenu i {
    width: 20px;
  }
  .navbar-collapse.collapse {
    position: relative;
    background-color: unset;
    top: 0;
  }
  .sub-menu-item h2 a {
    color: #fff;
    font-size: 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.6);
    /* font-weight: normal; */
  }
  .sub-menu-item p {
    color: #fff;
    /* font-size: 12px; */
    line-height: 1.5;
    padding-left: 15px;
    margin-bottom: 0.3rem;
  }
  .sub-menu-item a {
    /* text-transform: uppercase; */
    /* font-size: 10px; */
    color: #fff;
    opacity: 0.8;
    float: left;
  }
  .sub-menu-item a:hover {
    opacity: 1;
  }
  .sub-menu-item a:after {
    display: inline-block;
    width: 18px;
    height: 18px;
    margin-left: 0.5em;
    vertical-align: middle;
    content: "";
    fill: #fff;
    opacity: 1;
    background: url("/images/arrow-more.svg") no-repeat center center;
  }
  .sub-menu-item img {
    height: max-content;
  }
  .sub-megamenu::after {
    width: 18px;
    height: 18px;
    margin-left: 0.5em;
    vertical-align: middle;
    content: " ";
    opacity: 1;
    background: url("/images/arrow-right-white.png") no-repeat center center;
    float: right;
  }
  
  .sub-megamenu {
    box-sizing: border-box;
    position: relative;
  }
  .menu-level-2 {
    display: none;
    box-sizing: border-box;
    position: absolute;
    top: 20px;
    right: -90%;
    background: #ffffff;
    padding: 15px;
    z-index: 1;
    width: 180px;
    /* max-height: 0; overflow: hidden;
      opacity: 0;
      transition: max-height 0s 1.5s, opacity .4s 1s;
    
      pointer-events: none; */
  }
  .menu-level-2::before {
    content: "";
    position: absolute;
    top: 0;
    left: -20px;
    border-style: solid;
    border-width: 20px 0 0 20px;
    border-color: #fff transparent transparent transparent;
  }
  .menu-level-2 li {
    margin: 0px;
    padding: 3px 10px;
    border-bottom: 1px solid #ebebeb;
    color: #000000;
    font-size: 12px;
  }
  .menu-level-2 li:hover {
    background-color: #ebebeb;
  }
  
  .mega-menu-image {
    height: 25px;
    width: 25px;
  }

  .mega-menu-image-mr-28 {
    margin-right: 28px;
  }
  
  @media (max-width: 992px) {
    .megamenu {
      position: relative;
      width: auto !important;
      background: #000000;
    }
    .sm-menu {
      top: 0px;
    }
  
    .navbar-light .navbar-nav .nav-link {
      font-size: 20px;
      font-weight: normal;
      height: 50px;
    }
  }
  
  @media screen and (max-width: 767px) {
    .megamenu-container {
      margin-top: 0 !important;
    }
  }
  @media screen and (min-width: 768px) and (max-width: 991px) {
    .megamenu-container {
      margin-top: -28px !important;
    }
  }
  
  /* -- right icon css start-- */
  .d-lg-none.ml-auto .nav-link,
  .navbar-toggler {
    font-size: 18px;
    padding: 10px;
    transition: background-color 0.3s ease;
    color: #da9d26;
    background-color: #ffffff;
  }
  
  .d-lg-none.ml-auto .nav-link:hover,
  .navbar-toggler:hover {
    text-decoration: none;
  }
  
  .d-lg-none.ml-auto .nav-link i,
  .navbar-toggler-icon:after {
    margin-right: 5px;
  }
  
  /* Additional styling for the navbar toggler */
  .navbar-toggler {
    border: none;
    outline: none;
    color: #da9d26;
    background-color: #ffffff;
    border-radius: 0;
  }
  
  .navbar-toggler-icon:after {
    font-weight: 900;
    font-size: 20px;
    color: #da9d26;
  }
  .navbar-light .navbar-toggler-icon {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgb(217 156 38)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E");
  }

  .second-level-mega-menu {
      position: relative;
  }

  .third-level-mega-menu {
      position: absolute;
      background: #fff;
      left: 90%;
      top: 25%;
      width: 250px;
      padding: 5px;
      display: none;
      list-style: none;
      font-size: 14px;
      z-index: 1;
  }

  .third-level-mega-menu::before {
      content: "";
      position: absolute;
      top: 0; /* Adjust this value to control the triangle's position */
      left: -20px;
      border-style: solid;
      border-width: 20px 0 0 20px;
      border-color: #fff transparent transparent transparent;
  }

  .third-level-mega-menu li .display_content{
      width: auto;
      height: auto;
      border: 1px solid #ccc;
      border-radius: 5px;
      z-index: 9999;
      background: #fff;
      padding: 15px;
      max-height: 250px;
      overflow-y: auto;
      overflow-x: hidden;
  }
  .third-level-mega-menu li .menu-image-display{
      width: 80px;
      height: 80px;
      float: left;
      margin: 8px 5px;
  }

  .third-level-mega-menu li .menu-content-display{
      font-size: 14px;
      font-weight: normal;
  }
/*-- Custom Scrollbar--*/
  .third-level-mega-menu li .display_content::-webkit-scrollbar {
      width: 6px;
  }

  .third-level-mega-menu li .display_content::-moz-scrollbar {
      width: 6px;
  }

  .third-level-mega-menu li .display_content::-ms-scrollbar {
      width: 6px;
  }

  .third-level-mega-menu li .display_content::-webkit-scrollbar-thumb {
      background-color: #888;
      border-radius: 3px;
  }

  .third-level-mega-menu li .display_content::-moz-scrollbar-thumb {
      background-color: #888;
      border-radius: 3px;
  }

  .third-level-mega-menu li .display_content::-ms-thumb {
      background-color: #888;
      border-radius: 3px;
  }

  .third-level-mega-menu li .display_content::-webkit-scrollbar-track {
      background-color: transparent;
  }

  .third-level-mega-menu li .display_content::-moz-scrollbar-track {
      background-color: transparent;
  }

  .third-level-mega-menu li .display_content::-ms-track {
      background-color: transparent;
  }

  .third-level-mega-menu li .menu-content-display p {
      margin-bottom: 0 !important;
      word-break: break-all;
  }
  .third-level-mega-menu li .display_content .btn-show-more-less {
      font-size: smaller;
      color: #000000;
      -webkit-transition: 1s;
      -moz-transition: 1s;
      -o-transition: 1s;
      transition: 1s;
      padding: 2px;
      cursor: pointer;
      border: 1px solid #FFAD00;
      border-radius: 2px;
  }

  @media only screen and (min-width: 768px) and (max-width: 991px){
    .home .cp-main .megamenu-container {
      margin-top: 83px !important;
    }
  }

  .menu-loader-container {
    display: flex;
    align-items: center;
  }
  .menu-loader {
    border: 2px solid #f3f3f3; /* Light grey */
    border-top: 2px solid #000000; /* Blue */
    border-radius: 50%;
    width: 16px;
    height: 16px;
    animation: spin 1s linear infinite;
    margin-right: 5px; /* Space between loader and text */
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .navbar-nav .nav-link.dropdown-toggle:focus {
    outline: none;
    box-shadow: none;
  }
  </style>